import { http } from "../core";
const apiMessages = async (pageName) => {
    let response = await http.get(process.env.VUE_APP_PUBLICPATH + 'assets/message.json');
    response = response?.filter((item) => {
        return item.pageName == pageName;
    })[0];
    return response || null;
};

export { apiMessages };
